export default (event, setDataFunction, data, validate) => {
  const value = event.target.value;

  const isValid = validate && validate(value);
  setDataFunction({ ...data, value, isValid });
};
